import { render, staticRenderFns } from "./CSAllRequests.vue?vue&type=template&id=0ce2fa86&"
import script from "./CSAllRequests.vue?vue&type=script&lang=js&"
export * from "./CSAllRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports